module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NP-0e41d222c258f5bb2f72bf4cd29b2dde.png";